import Cookies from 'js-cookie';

const COOKIE_NAME = 'client_name';

export const getClientName = () => Cookies.get(COOKIE_NAME);
export const setClientName = (clientName: string) => Cookies.set(COOKIE_NAME, clientName);
export const removeClientName = () => Cookies.remove(COOKIE_NAME);
